"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var enhance = (0, recompose_1.compose)(recompose_1.pure);
exports.default = enhance(function (props) {
    return (React.createElement("div", { className: 'buttons' },
        React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/button/previous'), color: 'blue', disabled: props.customerId === null ||
                props.wizardStep < 1 ||
                props.fetchingCustomer === 'FETCHING', onClick: function () {
                props.changeStep(props.wizardStep - 1);
            } }),
        React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/button/next'), color: 'blue', disabled: props.customerId === null ||
                props.wizardStep > 2 ||
                props.fetchingCustomer === 'FETCHING', onClick: function () {
                props.changeStep(props.wizardStep + 1);
            } })));
});
